// src/AuthContext.js
import React, { createContext, useState, useContext } from 'react';

// Create a Context for the auth
export const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  // State to hold the token
  const [token, setToken] = useState(localStorage.getItem('token'));

  // Function to handle login (set token)
  const login = (newToken) => {
    setToken(newToken);
  };

  // Function to handle logout (remove token)
  const logout = () => {
    setToken(null);
    localStorage.removeItem('token');
  };

  return (
    <AuthContext.Provider value={{ token, login, logout }}>
      {children}
    </AuthContext.Provider>
  );

};